<template>
  <div class="modal-overlay" v-if="visible" @click.self="close">
    <div class="modal-card">
      <div class="modal-header">
        <h3>同步持仓</h3>
        <span class="close-btn" @click="close">✕</span>
      </div>
      
      <div class="modal-body">
        <div class="list-grid header-row" v-if="items.length > 0">
          <span class="col-code">代码</span>
          <span class="col-amount">持有金额</span>
          <span class="col-action"></span>
        </div>
        
        <transition-group name="list" tag="div">
          <div v-for="(item, index) in items" :key="index" class="list-grid input-row">
            <input 
              v-model="item.code" 
              placeholder="基金代码" 
              class="input-field code-input"
              maxlength="6"
              autocomplete="off"
            />
            <input 
              v-model.number="item.holding" 
              type="number" 
              placeholder="0.00" 
              class="input-field amount-input"
              autocomplete="off"
            />
            <div class="action-cell">
              <div class="remove-btn" @click="removeItem(index)" v-if="items.length > 1" title="删除">
                ✕
              </div>
            </div>
          </div>
        </transition-group>
        
        <div class="add-row-btn" @click="addItem">
          <span class="plus-icon">+</span> 添加一行
        </div>
      </div>

      <div class="modal-footer">
        <button class="complete-btn" @click="confirm">
          保存并同步
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SyncModal',
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      items: [
        { code: '', holding: '' }
      ]
    }
  },
  methods: {
    close() {
      this.$emit('close');
    },
    addItem() {
      this.items.push({ code: '', holding: '' });
    },
    removeItem(index) {
      this.items.splice(index, 1);
    },
    confirm() {
      // Filter out empty entries
      const validItems = this.items.filter(i => i.code && i.holding !== '');
      if (validItems.length > 0) {
        this.$emit('confirm', validItems);
        this.items = [{ code: '', holding: '' }]; // Reset
      }
      this.close();
    }
  }
}
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.45);
  backdrop-filter: blur(4px);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  padding: 20px;
  box-sizing: border-box;
  animation: fadeIn 0.2s ease-out;
}

.modal-card {
  background: white;
  width: 100%;
  max-width: 420px;
  border-radius: 20px;
  padding: 24px;
  max-height: 85vh;
  display: flex;
  flex-direction: column;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);
  animation: zoomIn 0.3s cubic-bezier(0.16, 1, 0.3, 1);
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  flex-shrink: 0;
}

.modal-header h3 {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: #1f1f1f;
}

.close-btn {
  font-size: 20px;
  color: #999;
  cursor: pointer;
  width: 28px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f5f5f5;
  border-radius: 50%;
  transition: all 0.2s;
}

.close-btn:hover {
  background: #e6e6e6;
  color: #666;
}

.modal-body {
  flex: 1;
  overflow-y: auto;
  margin-bottom: 20px;
  padding-right: 4px; /* Scrollbar space */
}

/* Custom Scrollbar */
.modal-body::-webkit-scrollbar {
  width: 4px;
}
.modal-body::-webkit-scrollbar-thumb {
  background: #ccc;
  border-radius: 2px;
}

/* Grid Layout System */
.list-grid {
  display: grid;
  grid-template-columns: 120px 1fr 40px;
  gap: 12px;
  align-items: center;
}

.header-row {
  padding-bottom: 8px;
  margin-bottom: 8px;
  border-bottom: 1px solid #f0f0f0;
  font-size: 12px;
  color: #999;
}

.col-code {
  padding-left: 12px; /* Match input padding */
}

.col-amount {
  padding-left: 12px; /* Match input padding */
}

.input-row {
  margin-bottom: 12px;
}

.input-field {
  width: 100%;
  box-sizing: border-box;
  padding: 10px 12px;
  border: 1px solid #eee;
  border-radius: 8px;
  font-size: 14px;
  outline: none;
  transition: all 0.2s;
  background: #f9f9f9;
}

.code-input {
  font-family: monospace;
  letter-spacing: 1px;
  text-align: center;
}

.action-cell {
  display: flex;
  justify-content: center;
  align-items: center;
}

.input-field:focus {
  border-color: #1890ff;
  background: white;
  box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.1);
}

.code-input {
  flex: 1.2;
  font-family: monospace;
  letter-spacing: 0.5px;
}

.amount-input {
  flex: 1.5;
  min-width: 0;
}

.remove-btn {
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #ff4d4f;
  background: rgba(255, 77, 79, 0.1);
  border-radius: 50%;
  cursor: pointer;
  font-size: 12px;
  transition: all 0.2s;
}

.remove-btn:hover {
  background: #ff4d4f;
  color: white;
}

.remove-placeholder {
  width: 24px;
}

.add-row-btn {
  color: #1890ff;
  text-align: center;
  padding: 12px;
  cursor: pointer;
  border: 1px dashed #bfbfbf;
  border-radius: 8px;
  margin-top: 16px;
  font-size: 14px;
  font-weight: 500;
  transition: all 0.2s;
  background: #fafafa;
}

.add-row-btn:hover {
  border-color: #1890ff;
  background: rgba(24, 144, 255, 0.02);
}

.modal-footer {
  margin-top: auto;
  flex-shrink: 0;
}

.complete-btn {
  width: 100%;
  background: linear-gradient(135deg, #1890ff 0%, #096dd9 100%);
  color: white;
  border: none;
  padding: 14px;
  border-radius: 12px;
  font-size: 16px;
  cursor: pointer;
  font-weight: 600;
  box-shadow: 0 4px 12px rgba(24, 144, 255, 0.3);
  transition: transform 0.2s;
}

.complete-btn:active {
  transform: scale(0.98);
}

/* List Transitions */
.list-enter-active, .list-leave-active {
  transition: all 0.3s;
}
.list-enter, .list-leave-to {
  opacity: 0;
  transform: translateX(-20px);
}

@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

@keyframes zoomIn {
  from { opacity: 0; transform: scale(0.95); }
  to { opacity: 1; transform: scale(1); }
}
</style>
